import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { BaseComponent } from '../../../../common/components/base.component';

@Component({
    templateUrl: './set.approved.component.html',
    styleUrls: ['./set.approved.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class SetApprovedComponent extends BaseComponent {

    hubApprovedForm: FormGroup;
    eventApproved: boolean;
    placeApproved: boolean;

    constructor(private fb: FormBuilder,
                private dialogRef: MatDialogRef<SetApprovedComponent>,
                @Inject(MAT_DIALOG_DATA) data) {
        super();
        this.eventApproved = data.eventApproved;
        this.placeApproved = data.placeApproved;

    }

    ngOnInit() {
        this.hubApprovedForm = this.fb.group({
            eventApproved: [this.eventApproved, []],
            placeApproved: [this.placeApproved, []],
        });
    }

    save() {
        this.dialogRef.close(this.hubApprovedForm.value);
    }

    close() {
        this.dialogRef.close();
    }
}


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/admin/accounts/set.approved/set.approved.component.ts